import { FormikHelpers } from "formik";
import { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

import { getCancelTokenSource, IHttpCancelTokenSource } from "@/browser";
import { applyApiErrors } from "@/components/Formik";
import {
  getConsultantProfileCompany,
  IConsultantProfile,
  IConsultantProfileDto,
  postConsultantProfile,
} from "@/data/consultant-profiles";
import { MessagesContext } from "@/eworkitComponents";

export const useCreateConsultantProfileFormAction = <TFormValues extends Partial<IConsultantProfile>>(
  messengerContext: string,
) => {
  const Messages = useContext(MessagesContext);

  const { t } = useTranslation("common");

  const tokenSource = useRef<IHttpCancelTokenSource | null>(null);

  const create = async (values: TFormValues, actions: FormikHelpers<TFormValues>) => {
    try {
      const data = values as IConsultantProfileDto;

      const company = getConsultantProfileCompany(data as IConsultantProfile);

      if (tokenSource.current) {
        tokenSource.current.cancel();
      }

      tokenSource.current = getCancelTokenSource();

      const response = await postConsultantProfile(
        {
          companyId: company && company.id,
        },
        data,
        {
          cancelToken: tokenSource.current!.token,
        },
      );

      return response;
    } catch (error) {
      Messages.addMessage({
        text: t("VALIDATION_MESSAGES.GENERAL"),
        type: "warning",
        context: messengerContext,
      });

      applyApiErrors(actions, error.payload);
      actions.setSubmitting(false);

      throw error;
    }
  };

  return create;
};
